module.exports = __webpack_public_path__ + "static/media/in.accb65b7.svg";